module.exports = __webpack_public_path__ + "static/media/sungate.405b67dc.svg";